import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6aa39fe72253d300147f2b3b_1789119871247_639f28cc/fishblast/src/app/not-found.tsx");
